import { ConfigLeafletEffects } from './config-leaflet.effects';
import { InfoLayerEffects } from './info-layer.effects';
import { HistoricalGpsEffects } from './historical-gps.effects';

export const effects = [ConfigLeafletEffects, InfoLayerEffects, HistoricalGpsEffects];
